export const isSafari = (() => {
  const uA = window.navigator.userAgent
  return /Safari/.test(uA) && !/Chrome|CriOS/.test(uA)
})()
